import api from '@/services/axiosApi'

export interface PreviewUrlSuggestion {
  url: string
  uniqueVisitors: number
  events: number
  sources: Array<'flow_executions' | 'campaign_exposures'>
}

export async function fetchPreviewUrlSuggestions(teamPid: string | number): Promise<PreviewUrlSuggestion[]> {
  const data = await api.get(`/api/${teamPid}/metrics/previewUrlSuggestions`).then((res) => res.data)
  return data.urls ?? []
}
